import { actions } from "./Reducer";

/**
 * Actions that fire saga watchers
 */
export const getArtisanProductAction = (id) => ({
  type : actions.GET_ARTISAN_PRODUCT,
  payload : id
})

export const getArtisanProductsAction = (body) => ({
  type: actions.GET_ARTISAN_PRODUCTS,
  payload: body,
});

export const createArtisanProductAction = (formData) => ({
  type: actions.CREATE_ARTISAN_PRODUCT,
  payload: formData,
});

export const updateArtisanProductAction = (id, formData) => ({
  type: actions.UPDATE_ARTISAN_PRODUCT,
  payload: {
    formData,
    id,
  },
});

export const addEditorReviewArtisanProduct = (id,formData) => ({
  type: actions.ADD_EDITOR_REVIEW_ARTISAN_PRODUCT,
  payload: {
    formData,
    id,
  }
})

export const getArtisanProductsPictures = () => ({
  type: actions.GET_ARTISAN_PRODUCTS_PICTURES
})

/**
 * Actions that are fired by redux-saga watchers
 */

export const getArtisanProductSuccessAction = (product) => ({
  type : actions.GET_ARTISAN_PRODUCT_SUCCESS,
  payload : product
})

export const getArtisanProductsSuccessAction = (products) => ({
  type: actions.GET_ARTISAN_PRODUCTS_SUCCESS,
  payload: products,
});

export const getArtisanProductsSuccessChangeAction = (products) => ({
  type: actions.GET_ARTISAN_PRODUCTS_CHANGE_SUCCESS,
  payload: products,
});
export const createArtisanProductSuccessAction = (product) => ({
  type: actions.CREATE_ARTISAN_PRODUCT_SUCCESS,
  payload: product,
});

export const updateArtisanProductSuccessAction = (product) => ({
  type: actions.UPDATE_ARTISAN_PRODUCT_SUCCESS,
  payload: product,
});

export const getArtisanProductsPicturesSuccess = (productsPictures) => ({
  type: actions.GET_ARTISAN_PRODUCTS_PICTURES_SUCCESS,
  payload: productsPictures
})

/**
 * Misc
 */

export const setArtisanProductsIsLoadingAction = (payload) => ({
  type: actions.SET_ARTISAN_PRODUCTS_IS_LOADING,
  payload,
});

export const setArtisanProductsCountAction = (count) => ({
  type: actions.SET_ARTISAN_PRODUCTS_COUNT,
  payload: count,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_AP_SEARCH_VALUE,
  payload: value,
});
